<template>

  <v-card>
    <v-card-title>
      <div class="headline">
        {{ title }}
      </div>
    </v-card-title>

    <v-card-text class="with-nav">

      <v-btn fab small class="btn-nav prev geogaming-dark-blue" @click.native="onClickPrevious">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>

      <div class="gif-wrapper">
        <img :src="gifPath" />
      </div>

      <v-btn fab small class="btn-nav next geogaming-dark-blue" @click.native="onClickNext">
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>

    </v-card-text>
  </v-card>

</template>

<script>
  export default {
    name: 'tutorial-gif-card',
    props: [
      'title',
      'gifPath',
    ],
    methods: {
      onClickPrevious() {
        this.$emit('previous')
      },
      onClickNext() {
        this.$emit('next')
      },
    },
  }
</script>

<style scoped lang="scss" type="text/scss">
  @import '../../assets/styles/colors.scss';

  .geogaming-dark-blue {
    color: $geogaming-dark-blue-color;
  }

  .card {
    .card__title {
      text-align: center;

      .headline {
        width: 100%;
        font-size: 20px !important;
        color: $geogaming-dark-blue-color;
        font-weight: bold;
      }
    }

    .with-nav {
      display: flex;
      align-items: center;
      padding-bottom: 40px;
    }

    .card__text {
      text-align: center;
      padding-left: 0;
      padding-right: 0;

      .gif-wrapper {
        flex: 1;

        img {
          width: 100%;
        }
      }

      .btn-nav {
        min-width: 40px;
        margin: 0;

        &.prev {
          left: 20px;
        }

        &.next {
          right: 20px;
        }

        &.geogaming-dark-blue {
          background-color: $geogaming-dark-blue-color;

          .icon {
            color: white;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/single/TutorialGifCard.vue